import React from "react";

import { useIncompletedAdsView } from "./hooks";
import LayoutTemplate from "../../components/common/layout-template";
import FormTextInput from "../../components/base/form-text-input";
import GenericTable from "../../components/common/generic-table";
import { Grid } from "@material-ui/core";

import "./style.css";

const IncompletedAdsView = () => {
  const {
    TABLE_COLUMNS,
    handleClickTableRow,
    handleSearchChange,
    isLoading,
    results,
    searchQuery,
    total,
  } = useIncompletedAdsView();

  return (
    <LayoutTemplate subTitle="Ads > Incomplete">
      <Grid
        container
        direction="column"
        alignItems="center"
        className="incompleted-ads-view"
      >
        <FormTextInput
          placeholder="IDs / Name / Phone / Email"
          value={searchQuery}
          className="text-input"
          icon={<i class="fas fa-search text-muted" />}
          iconPosition="end"
          onChangeInput={handleSearchChange}
        />
        <Grid item container xs={8}>
          <GenericTable
            tableColumns={TABLE_COLUMNS}
            tableData={results}
            total={total}
            isLoading={isLoading}
            onClickRow={handleClickTableRow}
          />
        </Grid>
      </Grid>
    </LayoutTemplate>
  );
};

export default IncompletedAdsView;
